(function ($) {

    $.fn.ProductImages = function () {
        return $(this).each(function () {
            var container = this;

            var productImages = $(".large-images li", container);
            var productThumbnails = $(".thumbnails .product-thumbnail", container);

            productThumbnails.click(function (e) {
                var i = productThumbnails.index(e.currentTarget);
                clearSelected();
                $(productImages[i]).addClass('selected');
                $(productThumbnails[i]).addClass('selected');
            });

            function clearSelected() {
                $(productThumbnails).removeClass("selected");
                $(productImages).removeClass("selected");
            }

            function selectFirst() {
                if (productImages.length && productThumbnails.length) {
                    $(productThumbnails[0]).addClass("selected");
                    $(productImages[0]).addClass("selected");
                }
            }

            selectFirst();

        });
    };
    $(document).ready(function () {
        $('.product-images').ProductImages();
        $('.product-images .thumbnails').slick({
            slidesToShow: 5, slidesToScroll: 5, responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3 } }
            ]
        });
    });
}(jQuery));
